var _style, _path, _polygon, _polygon2, _path2, _path3, _path4, _polygon3, _path5, _path6, _polygon4, _path7, _polygon5, _polygon6, _path8, _polygon7, _path9, _path10, _polygon8, _path11, _path12, _polygon9, _path13, _polygon10, _polygon11, _path14, _polygon12, _polygon13, _path15, _polygon14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUseagle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 359 81",
    style: {
      enableBackground: "new 0 0 359 81"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F738D;}\n\t.st1{fill:#003E52;}\n\t.st2{fill:#C2D500;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M19.3,27L5.6,40.5c-7.5,7.5-7.5,19.5,0,27c0,0,0,0,0,0L19.3,81l27.2-27L19.3,27z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000100372512007389983290000011016028864539602592_",
    className: "st0",
    points: "73.8,0 46.5,0 60.1,13.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000009580769576516093110000010718804747094216601_",
    className: "st1",
    points: "46.5,54 19.3,27 40.3,60.1 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_00000048500039308965375520000009721050688405987505_",
    className: "st2",
    d: "M46.5,0l40.9,40.5c7.5,7.5,7.5,19.5,0,27 c0,0,0,0,0,0L73.8,81L19.3,27L46.5,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_00000181794357287099261320000018338836835879129764_",
    className: "st2",
    d: "M153.8,44.3c0,11.9-7.4,20.8-21.6,20.8 s-21.7-8.9-21.7-20.8V13.2h11.3v30.7c0,6.2,4.3,10.9,10.4,10.9s10.3-4.7,10.3-10.9V13.2h11.3V44.3L153.8,44.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_00000049932134597431609400000017379172441519708590_",
    className: "st2",
    d: "M186.2,25.5c-1.8-2.3-5.4-3.4-8.2-3.4 c-3.2,0-7.6,1.4-7.6,5.2c0,9.2,23.6,3.3,23.6,21c0,11.3-9.2,16.7-19.8,16.7c-6.6,0-12.4-1.9-17.2-6.4l8-8.7c2.3,3,6.1,4.8,9.9,4.8 s7.8-1.7,7.8-5.3c0-9.3-24.1-4.3-24.1-21.2c0-10.8,9.5-16.5,19.6-16.5c5.8,0,11.4,1.5,15.7,5.3L186.2,25.5L186.2,25.5z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000139999450776020533410000013223562567559048631_",
    className: "st0",
    points: "201.6,13.2 237.3,13.2 232.9,17.5  206.3,17.5 206.3,35.5 231.3,35.5 226.9,39.8 206.3,39.8 206.3,59.5 234.1,59.5 229.8,63.8 201.6,63.8 201.6,13.2 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M265.8,49.9c0,6.4,0.1,10.1,0.7,13.9h-4.1c-0.3-1.6-0.4-3.5-0.4-5.4h-0.1c-2.5,4.2-6.1,6.2-11.7,6.2 c-5.7,0-11.8-2.8-11.8-9.8c0-10.1,12-11.1,18.6-11.1h5.1v-2c0-5.7-4.1-8-9.4-8c-3.9,0-7.2,1.2-10.2,3.7l-2.5-2.9 c3.2-3,8.4-4.7,12.8-4.7c8.1,0,13.3,3.6,13.3,12V49.9L265.8,49.9z M257.1,47.2c-7.2,0-14.5,1.8-14.5,7.4c0,4.1,4,6.2,7.6,6.2 c9.3,0,11.7-5.9,11.7-11.4v-2.2H257.1L257.1,47.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000083774688561762563570000003476301640336421014_",
    className: "st0",
    d: "M307.1,61.7c0,16.5-11,19.3-17.8,19.3 s-13.2-2.6-16.6-6.9l3.4-3.1c3,4.2,8,6.2,13.2,6.2c13.3,0,13.5-11.4,13.5-15.2v-4.6h-0.1c-2.5,3.9-7,6.4-12.7,6.4 c-9.9,0-17.9-7.7-17.9-17s8-17,17.9-17c5.7,0,10.1,2.5,12.7,6.4h0.1v-5.6h4.3V61.7L307.1,61.7z M289.7,33.8 c-7.3,0-13.3,5.9-13.3,13.1S282.4,60,289.7,60c7.3,0,13.3-5.9,13.3-13.1S297,33.8,289.7,33.8L289.7,33.8z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000137119976305070487940000006416914757202941357_",
    className: "st0",
    points: "315.3,9.7 319.7,9.7 319.7,63.8  315.3,63.8 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000178187588688192645080000002080880485631900548_",
    className: "st0",
    d: "M358,57.6c-3.4,5-8.6,7.1-14.5,7.1 c-10.2,0-17-7.2-17-17.5s7-17.3,16.7-17.3c10.3,0,15.7,7.8,15.7,15.5v3h-28.1c0,3.6,2.5,12.5,12.7,12.5c4.4,0,9.1-2.3,11.2-5.9 L358,57.6L358,57.6z M354.6,44.5c0-5.9-5.1-10.7-11.6-10.7c-9.5,0-12.2,9-12.2,10.7H354.6L354.6,44.5z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000149365811104863091640000012767164097574379142_",
    className: "st1",
    points: "110.6,74.7 114.5,74.7 114.5,75.4  111.3,75.4 111.3,77.4 114.3,77.4 114.3,78.1 111.3,78.1 111.3,80.8 110.5,80.8 110.5,74.7 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000129172543621430879340000008763522661984801465_",
    className: "st1",
    points: "118,74.7 122.1,74.7 122.1,75.4  118.8,75.4 118.8,77.3 121.8,77.3 121.8,78 118.8,78 118.8,80.2 122.2,80.2 122.2,80.8 118,80.8 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000133504358201441457750000007566779817871635338_",
    className: "st1",
    d: "M125.7,74.7h2.5c1.3,0,3.1,0.8,3.1,3.1 s-1.9,3.1-3.1,3.1h-2.5V74.7L125.7,74.7z M126.5,80.2h1.5c1.5,0,2.6-0.7,2.6-2.4s-1.1-2.4-2.6-2.4h-1.5V80.2L126.5,80.2z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000029739446591126196840000002786350737467945609_",
    className: "st1",
    points: "135.1,74.7 139.1,74.7 139.1,75.4  135.8,75.4 135.8,77.3 138.9,77.3 138.9,78 135.8,78 135.8,80.2 139.3,80.2 139.3,80.8 135.1,80.8 "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000022536665361723326470000017372671393826206108_",
    className: "st1",
    d: "M142.8,74.7h1.6c1.2,0,2.6,0.2,2.6,1.7 c0,0.9-0.6,1.5-1.6,1.6l1.8,2.8h-0.9l-1.7-2.8h-1v2.8h-0.8L142.8,74.7L142.8,74.7z M143.6,77.4h0.7c0.8,0,1.9,0,1.9-1 c0-0.9-0.8-1-1.6-1h-1.1V77.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000134928565088147056040000012055417012492512153_",
    className: "st1",
    d: "M153.2,74.7h0.7l2.7,6.2h-0.9l-0.7-1.5h-3.2 l-0.7,1.5h-0.9L153.2,74.7L153.2,74.7z M153.6,75.6L153.6,75.6l-1.4,3h2.6L153.6,75.6z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000024003286311434838260000006720592751527683501_",
    className: "st1",
    points: "160.1,74.7 160.8,74.7 160.8,80.2  163.8,80.2 163.8,80.8 160.1,80.8 "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_00000121275460700710130090000014461199746091249801_",
    className: "st1",
    d: "M176.7,75.9c-0.4-0.5-1-0.7-1.6-0.7 c-1.4,0-2.4,1.2-2.4,2.6c0,1.4,1,2.6,2.4,2.6c0.8,0,1.4-0.3,1.9-0.9l0.6,0.5c-0.6,0.7-1.4,1.1-2.4,1.1c-1.8,0-3.3-1.4-3.3-3.2 s1.4-3.2,3.3-3.2c0.9,0,1.7,0.3,2.3,1L176.7,75.9L176.7,75.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000075881788153262565870000012452650869442537129_",
    className: "st1",
    d: "M181,74.7h1.6c1.2,0,2.6,0.2,2.6,1.7 c0,0.9-0.6,1.5-1.6,1.6l1.8,2.8h-0.9l-1.7-2.8h-1v2.8H181V74.7L181,74.7z M181.8,77.4h0.7c0.8,0,1.9,0,1.9-1c0-0.9-0.8-1-1.6-1h-1.1 V77.4z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000032615750765474986660000015557406174915460506_",
    className: "st1",
    points: "189,74.7 193.1,74.7 193.1,75.4  189.8,75.4 189.8,77.3 192.9,77.3 192.9,78 189.8,78 189.8,80.2 193.3,80.2 193.3,80.8 189,80.8 "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000035531206872131245940000015859988835358708876_",
    className: "st1",
    d: "M196.8,74.7h2.5c1.3,0,3.1,0.8,3.1,3.1 s-1.9,3.1-3.1,3.1h-2.5V74.7L196.8,74.7z M197.5,80.2h1.5c1.5,0,2.6-0.7,2.6-2.4s-1.1-2.4-2.6-2.4h-1.5V80.2L197.5,80.2z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000062183671675769457330000001363747114866626945_",
    className: "st1",
    points: "206.1,74.7 206.9,74.7 206.9,80.8  206.1,80.8 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000112626989757837765130000008810795349190593440_",
    className: "st1",
    points: "215.3,75.4 213.2,75.4 213.2,80.8  212.4,80.8 212.4,75.4 210.3,75.4 210.3,74.7 215.3,74.7 "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_00000175290136312944155520000008382832668327490992_",
    className: "st1",
    d: "M228.6,78.5c0,1.3-0.7,2.5-2.4,2.5 c-1.8,0-2.4-1.2-2.4-2.5v-3.8h0.8v3.7c0,1,0.4,1.9,1.7,1.9c1.3,0,1.7-0.9,1.7-1.9v-3.7h0.8V78.5z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000169547742610232924490000011968861818313798590_",
    className: "st1",
    points: "232.7,74.7 233.7,74.7 237.4,79.8  237.4,79.8 237.4,74.7 238.2,74.7 238.2,80.8 237.2,80.8 233.5,75.7 233.5,75.7 233.5,80.8 232.7,80.8 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000005957769241373111460000007703170360705273503_",
    className: "st1",
    points: "242.3,74.7 243,74.7 243,80.8  242.3,80.8 "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000176019433592304037880000000491241148618029483_",
    className: "st1",
    d: "M246.8,77.8c0-1.9,1.4-3.2,3.4-3.2 c2,0,3.4,1.4,3.4,3.2c0,1.9-1.4,3.2-3.4,3.2C248.2,81,246.8,79.6,246.8,77.8z M252.7,77.8c0-1.4-1-2.6-2.5-2.6 c-1.5,0-2.5,1.1-2.5,2.6s1,2.6,2.5,2.6C251.6,80.3,252.7,79.2,252.7,77.8z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000165230987631920861600000015503142411744951201_",
    className: "st1",
    points: "257.2,74.7 258.2,74.7 261.9,79.8  261.9,79.8 261.9,74.7 262.7,74.7 262.7,80.8 261.7,80.8 258,75.7 258,75.7 258,80.8 257.2,80.8 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseagle);
export default __webpack_public_path__ + "static/media/useagle.536118bdba4a64028f66ca83a2ee41af.svg";
export { ForwardRef as ReactComponent };